import { api } from "@king-ict/eupisi-ui/utils";

const apiUrlPrefix: string = "announcement";

export const getAnnouncementDocumentById = async (id: number) => {
  return api.download(`${apiUrlPrefix}/document/${id}`) as Promise<any>;
};
